// src/utils/owner.js
// One place for "who is the owner". The email is the VERIFIED Firebase login email
// (App.js copies user.email from the auth token onto the signed-in user), never the
// editable profile field. Compared case-insensitively, trimmed. Nothing else in the
// browser may spell this address out; import from here. The server twin is
// functions-api/owner.js and firestore.rules isOwner() compares the same address.
export const OWNER_EMAILS = ["henry@teamedelstein.com"];

export function isOwnerEmail(email) {
  const e = String(email || "").trim().toLowerCase();
  return !!e && OWNER_EMAILS.some((o) => o.toLowerCase() === e);
}

// The owner's powers. False while the owner is using View As (user.viewAsRole, set only in
// memory by applyViewAs in utils/roles.js), so every owner-only menu item, page and button
// disappears exactly as it would for the role he is viewing as. The database still knows
// him (firestore.rules), so anything he does is still saved as him.
export function isSuperAdminOwner(user) {
  return !!user && !user.viewAsRole && isOwnerEmail(user.email);
}

// May this person use the owner's View As switch? The owner by email, WHATEVER he is
// viewing as, so the switch and the "Viewing as" banner never vanish with his other powers.
// Viewing as a specific person, the user in memory is a copy of THEIR record, so his own
// is read from realUser (utils/roles.js applyViewAsPerson; memory only, never saved).
export function canUseViewAs(user) {
  if (!user) return false;
  if (user.viewAsPersonId) return !!user.realUser && isOwnerEmail(user.realUser.email);
  return isOwnerEmail(user.email);
}
